export default __webpack_public_path__ + "static/media/Shri-Yantra-Temple.31a4782d.jpg";